import { render, staticRenderFns } from "./table52.vue?vue&type=template&id=0d2d3828&scoped=true&"
import script from "./table52.vue?vue&type=script&lang=js&"
export * from "./table52.vue?vue&type=script&lang=js&"
import style0 from "./table52.vue?vue&type=style&index=0&id=0d2d3828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d3828",
  null
  
)

export default component.exports